import React, { useState, useEffect, useCallback } from "react";
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import StrikeThroughButton from "./strikethroughcomponent";

function Tasks( {setLoading} ) {
    const [tasks, setTasks] = useState([])
    const [newTask, setNewTask] = useState({
        title: '',
        note: '',
        date: new Date()
    });
    let sortedTasks = [...tasks].sort((a, b) => a.isChecked - b.isChecked);

    const getTasks = useCallback(async () => {
        setLoading(true)
        const data = {
            action: 'get_tasks',
            key: process.env.REACT_APP_customApiKey,
        }
        const URL = process.env.REACT_APP_API_URL + '/api'
        try {
            const res = await axios.post(URL, data);
            let temp_tasks = []
            for (let i = 0; i < res.data.tasks.length; i++) {
                temp_tasks.push({ id: i, google_id: res.data.tasks[i][3], title: res.data.tasks[i][0], note: res.data.tasks[i][1], date: res.data.tasks[i][2], isChecked: false })
            }
            setTasks(temp_tasks)
        } catch (error) {
            console.error('Error:', error);
        }
        setLoading(false)

    }, [setLoading]);
    useEffect(() => {
        getTasks();
    }, [getTasks]);
    const handleSubmit = async () => {
        setLoading(true)
        const data = {
            action: 'add_task',
            key: process.env.REACT_APP_customApiKey,
            date: newTask.date.toISOString(),
            title: newTask.title,
            notes: newTask.note
        };
        setNewTask({ title: '', note: '', date: new Date() });

        const URL = process.env.REACT_APP_API_URL + '/api'
        try {
            const res = await axios.post(URL, data);
            console.log(res.data[0])
            getTasks()
        } catch (error) {
            console.error('Error:', error);
        }
        setLoading(false)

    }

    const toggleTask = (id) => {
        setTasks(tasks.map(task =>
            task.id === id ? { ...task, isChecked: !task.isChecked } : task
        ));
    };

    const updateTasks = async () => {
        setLoading(true)
        const completedTasks = []
        const incompleteTasks = []
        for (let i = 0; i < tasks.length; i++) {
            if (tasks[i].isChecked) {
                completedTasks.push(tasks[i].google_id)
            } else {
                incompleteTasks.push(tasks[i].google_id)
            }
        }
        const data = {
            action: 'update_tasks',
            key: process.env.REACT_APP_customApiKey,
            completedTasks: completedTasks,
            incompleteTasks: incompleteTasks
        };
        const URL = process.env.REACT_APP_API_URL + '/api'
        try {
            await axios.post(URL, data);

        } catch (error) {
            console.error('Error:', error);
        }
        setLoading(false)
    }
    // Sort tasks to move checked ones to the bottom
    sortedTasks = [...tasks].sort((a, b) => a.isChecked - b.isChecked);


    return <div className="shadow-lg rounded-sm p-3">

        <h1 className="text-xl md:text-3xl text-black font-bold">Assignments</h1>
        <a className="text-red-500 underline" href="https://calendar.google.com/calendar/u/0/r/tasks?cid=mhrd.org_t5r5v3undg0l95bet95c6pistc%2540group.calendar.google.com">Google Tasks</a>
        <div className="w-[20rem] md:w-[30rem] m-auto mt-4">
            <h2 className="text-base md:text-xl font-bold mb-2">Add New Task</h2>
            <div className="flex flex-col gap-2">
                <input
                    type="text"
                    placeholder="Title"
                    value={newTask.title}
                    onChange={(e) => setNewTask({ ...newTask, title: e.target.value })}
                    className="p-2 border border-gray-300 rounded"
                />
                <DatePicker
                    selected={newTask.date}
                    onChange={(date) => setNewTask({ ...newTask, date })}
                    dateFormat="MM/dd/yyyy"
                    className="p-2 border border-gray-300 rounded w-full"
                />
                <textarea
                    placeholder="Note"
                    value={newTask.note}
                    onChange={(e) => setNewTask({ ...newTask, note: e.target.value })}
                    className="p-2 border border-gray-300 rounded"
                />

                <button
                    onClick={handleSubmit}
                    className="outline outline-red-500 outline-2 bg-red-500 text-white duration-300 hover:bg-white hover:text-red-500 p-2 rounded-lg mt-4"
                >
                    Create Task
                </button>
            </div>
        </div>
        <div className="m-auto gap-4 flex flex-col pt-2">
            <h2 className="text-base md:text-xl font-bold mb-2">Existing Tasks</h2>

            {sortedTasks.map((task) => (
                <StrikeThroughButton key={task.id} google_id={task.google_id} title={task.title} note={task.note} date={task.date} click={() => toggleTask(task.id)} />

            ))}
            <button
                onClick={updateTasks}
                className="outline outline-red-500 outline-2 bg-red-500 text-white duration-300 hover:bg-white hover:text-red-500 p-2 rounded-lg mt-4"
            >
                Update Tasks
            </button>
        </div>

    </div>
}
export default Tasks;